function updateArray(array: any[], updatedItem: any, index: number) {
  const next = Array.isArray(array) ? array.slice() : [];
  const needed = index - next.length + 1;
  if (needed > 0) {
    for (let i = 0; i < needed; i++) {
      next.push({});
    }
  }
  next[index] = updatedItem;
  return next;
}

export default updateArray;
